module.exports = __webpack_public_path__ + "images/help/video-calendar-small-ca86b99b3a86937b108ad1cdb04ca6b8.png";